import React from 'react'

import styles from './style.module.css'

export type LabelValueItem = {
  label: React.ReactNode
  value: React.ReactNode
}

export type LabelValueListProps = {
  items: LabelValueItem[]
  labelWidth?: number // px。既定 107
}

export const LabelValueList: React.FC<LabelValueListProps> = ({ items, labelWidth = 107 }) => {
  return (
    <dl className={styles.list}>
      {items.map((item, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={index} className={styles.row}>
          <dt className={styles.label} style={{ width: labelWidth, minWidth: labelWidth }}>
            {item.label}
          </dt>
          <dd className={styles.value}>{item.value}</dd>
        </div>
      ))}
    </dl>
  )
}
